













































































































































































































import { Component, Vue, Emit, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { vuex } from '@/store';
import rest from "@/rest";
import { signalrEventBus } from "@/main";
// components
import ExpandableCard from '../Shared/ExpandableCard.vue';
import MarkdownEditor from '../Shared/MarkdownEditor.vue';
// interfaces
import { ParamDictionary } from '@/interfaces/ParamDictionary';
import { ExerciseVM } from '@/interfaces/ExerciseVM';
import { CourseElementVm } from '@/interfaces/CourseElementVm';
import { CourseElementType } from '@/interfaces/CourseElementType';
import { courseElementTypeItems } from "@/interfaces/Types";
import { CustomizationVm } from '@/interfaces/CustomizationVm';
import { ExBundleVM } from '@/interfaces/ExBundleVM';

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
    components: {
      ExpandableCard,
      MarkdownEditor
    }
  })
  export default class ImageElementSettings extends Vue {
  @customization.Getter customizationSettings!: CustomizationVm;
  @globals.Getter selectedBundle!: ExBundleVM | null;
  @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter selectedElement!: CourseElementVm | null;
  @globals.Action refreshSelectedElement!: () => Promise<void>;
  @globals.Getter selectedLanguageCode!: string | null;
  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;
  isBusyOnAdjustImage = false;
  isBusyOnCreateAiSummary = false;
  isBusyOnCreateAltText = false;
  isBusyOnConvertImage = false;
  showMarkdownEditor = false;
  width = 0;
  height = 0;
  enableWidth = false;
  enableHeight = false;
  id = "";
  convertImageTo: string = '';

  mounted() {
    if (!this.selectedElement) return;
    this.enableWidth = !!this.selectedElement.width;
    if (this.enableWidth) this.width = Number(this.selectedElement.width);
    this.enableHeight = !!this.selectedElement.height;
    if (this.enableHeight) this.height = Number(this.selectedElement.height);
  }

  created() {
    // SignalR event listener
    signalrEventBus.$on('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  beforeDestroy() {
    // clearAllBodyScrollLocks();
    // Make sure to cleanup SignalR event handlers when removing the component
    signalrEventBus.$off('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  // SignalR events
  async backgroundTaskEvent(response: { id: string, progress: number, message: string, status: string }) {
    if (this.id !== response.id) return;
    console.log("ImageElementSettings > Background task event:", response);
    if (response.status == "INF") {
      vuex.ux.SB_SUCCESS({
        message: response.message,
        timeout: 1500
      });
      return;
    }

    // Reload the element to get the updated AI summary
    await this.refreshSelectedElement();
    // Update MediaPool
    this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list

    this.isBusyOnCreateAiSummary = false;
  }

  onConvert() {
    if (!this.selectedElement) return;
    if (!this.selectedElement.textAlign)
      this.selectedElement.textAlign = "center";
    if (!this.selectedElement.darkMode)
      this.selectedElement.darkMode = "auto";
    this.selectedElement.fillContainer = true;
    this.selectedElement.type = "HeroHeadline";
  }

  get fileName(): string {
    if (!this.selectedElement || !this.selectedElement.contentUrl) return "";
    return this.$globalHelper.extractFileName(this.selectedElement.contentUrl);
  }

  async onCreateAiSummary(): Promise<void> {
    if (!this.selectedElement || !this.selectedBundle) return;

    await this.$l3rnOnlineHub.ensureConnection();
    this.isBusyOnCreateAiSummary = true;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
    params.dictionary!["BundleId"] = this.selectedBundle.id.toString();
    params.dictionary!["FileName"] = this.$globalHelper.extractFileName(this.selectedElement.contentUrl ?? "");
    params.dictionary!["LanguageCode"] = this.selectedLanguageCode || "de-DE";

    await rest.url("contentManager/createAiSummary").post(params)
      .then(async (response) => {
        console.log("ImageElementSettings > Create AI Summary response:", response);
        if (!response || !this.selectedElement || !this.selectedBundle) return;
        this.id = response;
      })
      .catch(err => {
      })
  }

  @Watch("width")
  async onWidthChange() {
    if (!this.selectedElement) return;
    if (!this.enableWidth) {
      this.selectedElement.width = "";
      return;
    }
    this.selectedElement.width = this.width.toString();
  }

  onEnableWidthChanged() {
    if (!this.selectedElement) return;
    if (this.enableWidth) {
      if (this.width < 50)
        this.width = 150;
      this.selectedElement.width = this.width.toString();
      return;
    }

    this.selectedElement.width = "";
  }

  onEnableHeightChanged() {
    if (!this.selectedElement) return;
    if (this.enableHeight) {
      if (this.height < 50)
        this.height = 150;
      this.selectedElement.height = this.height.toString();
      return;
    }

    this.selectedElement.height = "";
  }

  @Watch("height")
  async onHeightChange() {
    if (!this.selectedElement) return;
    if (!this.enableHeight) {
      this.selectedElement.height = "";
      return;
    }
    this.selectedElement.height = this.height.toString();
  }

  get imageWidth() {
    if (!this.enableWidth) return "";
    return this.width.toString();
  }

  get imageHeight() {
    if (!this.enableHeight) return "";
    return this.height.toString();
  }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }

  get canAdjustImage(): boolean {
      if (!this.customizationSettings || !this.selectedElement) return false;
      // const model = (this.customizationSettings.imageGenerationModel ?? '').toString();
      return this.customizationSettings.enableAi &&
        // model.startsWith('gemini') &&
        // model.endsWith('-image') &&
        !!this.selectedElement.contentUrl;
  }

  private async createAltText(): Promise<void> {
    this.isBusyOnCreateAltText = true;

    if (!this.selectedElement) return;
    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["BundleId"] = this.selectedExercise.exBundleId!.toString();
    params.dictionary!["FilePath"] = this.selectedElement.contentUrl ?? "";
    params.dictionary!["RelativePath"] = "";
    params.dictionary!["LanguageCode"] = this.selectedLanguageCode || "de-DE";

    rest.url("contentManager/createImageAltText").post(params)
      .then((response) => {
        console.log("response", response);
        if (this.selectedElement && response) {
          this.selectedElement.altText = response;
        }

        this.isBusyOnCreateAltText = false;
      })
      .catch(err => {
      });
  }

  private async createImage(): Promise<void> {
    this.isBusy = true;

    if (!this.selectedElement) return;
    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["BundleId"] = this.selectedExercise.exBundleId!.toString();
    // params.dictionary!["ExerciseId"] = this.selectedExercise.id!.toString();
    params.dictionary!["FilePath"] = this.selectedElement.contentUrl ?? "";
    params.dictionary!["RelativePath"] = "";
    params.dictionary!["Prompt"] = this.selectedElement.text ?? "";
    params.dictionary!["ChangePrompt"] = "";
    params.dictionary!["AspectRatio"] = this.selectedElement.aspectRatio ?? "";
    params.dictionary!["Style"] = this.selectedElement.style ?? "";
    const accent = (this.$vuetify.theme.themes as any)["light"]?.accent ?? (this.$store.state.ux?.colorAccent ?? "#006064");
    params.dictionary!["AccentColor"] = accent;

    rest.url("contentManager/createImage").post(params)
      .then((response) => {
        console.log("response", response);
        if (this.selectedElement && response) {
          this.selectedElement.contentUrl = response;
          this.selectedElement.invisible = false;
          this.selectedElement.createdWithAi = true;
        }

        this.isBusy = false;
        this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list
      })
      .catch(err => {
      });
  }

  private async convertImage(): Promise<void> {
    if (!this.selectedElement || !this.selectedExercise) return;

    if (!this.convertImageTo) return;

    this.isBusyOnConvertImage = true;

    let params: ParamDictionary = { dictionary: {} };
    params.dictionary!["BundleId"] = this.selectedExercise.exBundleId!.toString();
    params.dictionary!["FilePath"] = this.selectedElement.contentUrl ?? "";
    params.dictionary!["TargetFormat"] = this.convertImageTo;

    rest.url("contentManager/convertImage").post(params)
      .then(async (response) => {
        if (this.selectedElement && response) {
          this.selectedElement.contentUrl = null;
          await this.$globalHelper.delay(5);
          this.selectedElement.contentUrl = response;
          this.selectedElement.invisible = false;
        }

        this.isBusyOnConvertImage = false;
        this.$root.$emit('fileListUpdate:MediaPool');
      })
      .catch(err => {
        this.isBusyOnConvertImage = false;
      });
  }

  private async adjustImage(): Promise<void> {
    this.isBusyOnAdjustImage = true;

    if (!this.selectedElement) return;
    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["BundleId"] = this.selectedExercise.exBundleId!.toString();
    // params.dictionary!["ExerciseId"] = this.selectedExercise.id!.toString();
    params.dictionary!["FilePath"] = this.selectedElement.contentUrl ?? "";
    params.dictionary!["RelativePath"] = "";
    params.dictionary!["Prompt"] = "";
    params.dictionary!["ChangePrompt"] = this.selectedElement.changePrompt ?? "";
    params.dictionary!["AspectRatio"] = this.selectedElement.aspectRatio ?? "";
    params.dictionary!["Style"] = this.selectedElement.style ?? "";
    const accent = (this.$vuetify.theme.themes as any)["light"]?.accent ?? (this.$store.state.ux?.colorAccent ?? "#006064");
    params.dictionary!["AccentColor"] = accent;

    rest.url("contentManager/createImage").post(params)
      .then((response) => {
        console.log("response", response);
        if (this.selectedElement && response) {
          this.selectedElement.contentUrl = response;
          this.selectedElement.invisible = false;
          this.selectedElement.createdWithAi = true;
        }

        this.isBusyOnAdjustImage = false;
        this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list
      })
      .catch(err => {
      });
  }

  // Liste für Bild-Positionen: deutsches Label (text), englischer Wert (value)
  get positionItems() {
    return [
      { text: 'Links oben', value: 'left top' },
      { text: 'Links zentriert', value: 'left center' },
      { text: 'Links unten', value: 'left bottom' },
      { text: 'Oben', value: 'top' },
      { text: 'Zentriert', value: 'center' },
      { text: 'Unten', value: 'bottom' },
      { text: 'Rechts oben', value: 'right top' },
      { text: 'Rechts zentriert', value: 'right center' },
      { text: 'Rechts unten', value: 'right bottom' }
    ];
  }

  get formatItems(): string[] {
    const all = ['', '.webp', '.png', '.avif', '.jpg'];
    try {
      if (!this.selectedElement || !this.selectedElement.contentUrl) return all;
      const m = this.selectedElement.contentUrl.match(/\.([a-zA-Z0-9]+)(?:[?#]|$)/);
      if (!m) return all;
      const ext = '.' + m[1].toLowerCase();
      return all.filter(i => i !== ext);
    } catch (e) {
      return all;
    }
  }
  }
  